import { render, staticRenderFns } from "./AmountInputComponent.vue?vue&type=template&id=4a8bd708&"
import script from "./AmountInputComponent.vue?vue&type=script&lang=js&"
export * from "./AmountInputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports